import { Card, CardBody, Col } from "reactstrap";
import CardHeaderCommon from "../../../../CommonElements/CommonCardHeader/CardHeaderCommon";
import { SalesAnalyticsHeading } from "../../../../utils/Constant";
import { LI, P, UL } from "../../../../AbstractElements";
import { salesCircleData } from "../../../../Data/Dashboard/EcommerceDashboard/EcommerceDashboard";
import SalesAnalyticsChart from "./SalesAnalyticsChart";

const SalesAnalytics = () => {
  return (
    <Col xl="6">
      <Card className="sales-chart">
        <CardHeaderCommon
          title={SalesAnalyticsHeading}
          mainTitle="Yearly"
          firstItem="Today"
          secondItem="Tomorrow"
          thirdItem="Yesterday"
        />
        <CardBody className="pt-0">
          <UL className="flex-row simple-list">
            {salesCircleData.map((data, i) => (
              <LI className="me-3" key={i}>
                <span className={`circle bg-${data.color} me-1`}></span>
                <P>
                  {data.status}<span>({data.amount})</span>
                </P>
              </LI>
            ))}
          </UL>
          <SalesAnalyticsChart />
        </CardBody>
      </Card>
    </Col>
  );
};

export default SalesAnalytics;
